
export function isEmpty(str) {
  return (!str || 0 === str.length)
}
